<div class="inner-card">
  <div class="d-flex flex-column gap-2 flex-grow-1">
    <div class="d-flex gap-2 align-items-center">
      <app-radio-button-input
        *ngIf="showRadioButton && radioFormControl"
        [controlId]="radioControlId"
        [formControl]="radioFormControl"
        [name]="radioName"
        [value]="radioValue"
        (selectionChange)="selected.emit()" />
      <app-form-option-label [labelFor]="radioControlId">{{ label }}</app-form-option-label>
    </div>
    <div class="option-details" [style.padding-inline-start.rem]="showRadioButton ? 2.4 : 0">{{ name }}</div>
  </div>
  <div class="d-flex flex-column gap-2 align-items-end">
    <div class="option-age" i18n>Age: {{ dateOfBirth | age }}</div>
    <div class="option-details" i18n>Date of Birth: {{ formattedDateOfBirth }}</div>
  </div>
</div>
